import { useQuery } from 'react-query';
import { CustomsTasksService } from '../../services';

export const useCustomsTask = (id?: string) => {
  const query = useQuery(['customs-task', id], () => CustomsTasksService.getById(id!), { enabled: !!id, cacheTime: 0 });

  return {
    data: query.data?.status === 200 ? query.data.data : undefined,
    isLoading: query.isLoading,
    isError: query.isError || query.data?.status === 400,
  };
};
